import React from 'react';
import Grid from "@mui/material/Grid";
import { Checkbox, FormControlLabel, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { parse, format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { setComplimentaryActivities } from "../../../redux/actions/transactionActions";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexGrow: 1,
        marginBottom: theme.spacing(8)
    },
    paper: {
        padding: theme.spacing(0),
        width: '100%',
        margin: 'auto',
    },
    mainContainer: {
        padding: theme.spacing(1),
    },
    ActivityListInfo: {
        display: 'flex',
        width:'100%',
        paddingBottom:0,
        paddingTop:0,
        '-webkit-flex-direction': 'column',
        flexDirection: 'column',
        justifyContent:'space-between',
        height:'100%',
    }
}));

const ComplimentaryActivity = ({ activity }) => {
    const { activities: complimentary } = useSelector(state => state.transactions);
    const classes = useStyles();
    const dispatch = useDispatch();

    const currentValues = complimentary ? complimentary[activity.id] || [] : [];

    const handlerActivity = (event) => {
        const { checked, name } = event.target;
        dispatch(setComplimentaryActivities(activity.id, name, checked));
    }

    const getFormattedDate = (activityDate) => {
        const parsedDate = parse(activityDate, "yyyy-MM-dd'T'HH:mm:ss", new Date());
        return `${format(parsedDate, 'h:mm a')} on ${format(parsedDate, 'MMMM dd, yyyy')}`;
    };

    return (
        <div className={classes.root}>
            <Grid container spacing={3} direction="column" justify="center">
                {activity && 'availabilities' in activity && Object.keys(activity['availabilities']).length > 0 && Object.keys(activity['availabilities']).map((dates) => (
                    <Grid item container className={classes.mainContainer} key={dates}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <Paper className={classes.paper} elevation={3}>
                                    <Grid item xs={12} sm={12}>
                                        <FormControlLabel
                                            className={'cleanCheckbox'}
                                            control={<Checkbox
                                                checked={currentValues.includes(dates)}
                                                name={dates}
                                                onChange={handlerActivity}
                                                color="primary"
                                            />}
                                            label={`${activity['name']} - ${getFormattedDate(activity['availabilities'][dates]['date'])}`}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} className={'imageContainer'} sx={{maxHeight:'229px'}}>
                                        <img src={activity['image']} alt="Activity" width={'100%'} className={'activityImage'}/>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default ComplimentaryActivity;
